export enum ProductType {
  Artist = 'Artists',
  EntertainmentEvent = 'EntertainmentEvents',
  Restaurant = 'dining',
  Hotel = 'accommodation',
  Brand = 'Brand',
  PrimaryInterest = 'Primary interest',
}
